<template>
  <GroupQueryBuilder
    :class="[this.loading && 'overlay overlay-block']"
    :model="this.model"
    :regra="this.regraFiltro"
    :operadores="this.operadores"
    :showRemove="false"
    :descricaoFiltro="this.consultaAvancada.descricao"
  />
  <div class="row">
    <div class="col-auto mb-4">
      <button
        @click="this.aplicarFiltro()"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Aplicar todos os filtros adicionados"
        class="btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white"
      >
        <i class="bi bi-funnel-fill me-2 fs-3"></i>Filtrar
      </button>
    </div>
    <div class="col-auto mb-4">
      <button
        @click="this.limparFiltros()"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Limpar todos os filtros adicionados"
        class="btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white"
      >
        <i class="bi bi-funnel me-2 fs-3"></i>Limpar
      </button>
    </div>
    <div class="col-auto mb-4">
      <button
        v-if="this.consultarConsultaAvancada"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Salvar filtro"
        @click="this.salvarFiltro()"
        class="btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white"
      >
        <i class="bi bi-bookmark-plus me-2 fs-3"></i>Salvar
      </button>
    </div>
    <div class="col-auto mb-4">
      <button
        v-if="this.consultarConsultaAvancada"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Carregar filtros salvos"
        @click="this.modalConsultaAvancada(true)"
        class="btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white"
      >
        <i class="bi bi-bookmark-star me-2 fs-3"></i>Carregar
      </button>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalQueryBuilder'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
  <EditarDescricaoFiltroModal
    v-if="exibirEditarDescricaoFiltro"
    :consultaAvancada="this.consultaAvancada"
    @exibirModalEditarDescricaoFiltro="modalEditarDescricaoFiltro"
    @confirmarEditarDescricaoFiltro="confirmarEditarDescricaoFiltro"
  ></EditarDescricaoFiltroModal>
  <ConsultaAvancadaModal
    v-if="exibirConsultaAvancada"
    :tabela="this.viewModel"
    @exibirModalConsultaAvancada="modalConsultaAvancada"
    @selecionarConsultaAvancada="selecionarConsultaAvancada"
  ></ConsultaAvancadaModal>
</template>

<script>
import GroupQueryBuilder from "@/components/query-builder/GroupQueryBuilder.vue";
import EditarDescricaoFiltroModal from "@/components/query-builder/EditarDescricaoFiltroModal.vue";
import ConsultaAvancadaModal from "@/components/query-builder/ConsultaAvancadaModal.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import $bus from "@/utils/event.js";
import { mapState } from "vuex";

const consultaAvancadaInicializada = {
  id: 0,
  descricao: "",
  tabela: "",
  select: "",
  filter: "",
};

export default {
  name: "QueryBuilder",
  emits: ["gerarFiltro", "atualizarSelectFiltro"],
  props: {
    viewModel: { type: String, required: true },
    selectQuery: { type: String, required: true },
    selectFiltro: { type: Object, required: true },
  },
  components: {
    GroupQueryBuilder,
    EditarDescricaoFiltroModal,
    ConsultaAvancadaModal,
    LoadingModal,
  },
  methods: {
    modalConsultaAvancada(exibir) {
      this.exibirConsultaAvancada = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_consulta_avancada_consultar");
        }, 100);
      }
    },
    modalEditarDescricaoFiltro(exibir) {
      this.exibirEditarDescricaoFiltro = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_editar_descricao_filtro");
        }, 100);
      }
    },
    async confirmarEditarDescricaoFiltro(consulta) {
      this.consultaAvancada.descricao = consulta.descricao;
      await this.exibirModalLoading(true);
      try {
        var ret = await this.$store.dispatch(
          "consultaAvancada/postConsultaAvancada",
          this.consultaAvancada
        );
        if (ret.Success === true) {
          this.consultaAvancada.id = ret.Data.id;
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(ret.Message);
          this.aplicarFiltro();
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        console.log(error);
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalQueryBuilder");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalQueryBuilder");
        await this.sleep(100);
        this.loading = false;
      }
    },
    async getSchema() {
      try {
        var ret = await this.$store.dispatch(
          "schema/getSchema",
          this.viewModel
        );
        if (ret.Success === true) {
          this.model = JSON.parse(ret.Data);
          //console.log(JSON.stringify(this.model));
        }
      } catch (error) {
        console.log(error);
      }
    },
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showQuestionAlert(text) {
      return await Swal.fire({
        text: text,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "ENTER - Sim",
        cancelButtonText: "ESC - Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        text: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    async salvarFiltro() {
      if (this.gerarFiltroOData() != "") {
        try {
          this.consultaAvancada.tabela = this.viewModel;
          this.consultaAvancada.select = JSON.stringify(this.selectFiltro);
          this.consultaAvancada.filter = JSON.stringify(this.regraFiltro);
          if (this.consultaAvancada.id === 0) {
            if (this.adicionarConsultaAvancada === false) {
              await this.showInvalidAlert(
                "Usuário não tem permissão para salvar o filtro!"
              );
            } else {
              this.modalEditarDescricaoFiltro(true);
            }
          } else {
            if (this.editarConsultaAvancada === false) {
              await this.showInvalidAlert(
                "Usuário não tem permissão para atualizar o filtro!"
              );
            } else {
              let alert = await this.showQuestionAlert(
                "Deseja atualizar o filtro selecionado?"
              );
              if (alert.isConfirmed) {
                await this.exibirModalLoading(true);
                var retPut = await this.$store.dispatch(
                  "consultaAvancada/putConsultaAvancada",
                  this.consultaAvancada
                );
                if (retPut.Success === true) {
                  await this.exibirModalLoading(false);
                  await this.showSuccessAlert(retPut.Message);
                  this.aplicarFiltro();
                }
              } else {
                if (this.adicionarConsultaAvancada === false) {
                  await this.showInvalidAlert(
                    "Usuário não tem permissão para salvar o filtro!"
                  );
                } else {
                  this.consultaAvancada.id = 0;
                  this.consultaAvancada.descricao = "";
                  this.modalEditarDescricaoFiltro(true);
                }
              }
            }
          }
        } catch (error) {
          await this.exibirModalLoading(false);
          console.log(error);
        }
      } else {
        await this.showInvalidAlert("Nenhum filtro foi selecionado!");
      }
    },
    async selecionarConsultaAvancada(consulta) {
      this.consultaAvancada = JSON.parse(JSON.stringify(consulta));
      var filter = JSON.parse(consulta.filter);
      var select = JSON.parse(consulta.select);
      this.regraFiltro.regras.splice(0, this.regraFiltro.regras.length);
      this.regraFiltro.condicao = filter.condicao;
      this.regraFiltro.regras = JSON.parse(JSON.stringify(filter.regras));
      this.$emit("atualizarSelectFiltro", select);
    },
    limparFiltros() {
      this.regraFiltro.regras.splice(0, this.regraFiltro.regras.length);
      this.regraFiltro.regras.push({
        campo: "",
        operador: "",
        tipo: "",
        valor: "",
        valor_entre: "",
        utc: false,
      });
      this.consultaAvancada = JSON.parse(
        JSON.stringify(consultaAvancadaInicializada)
      );
      this.$emit("gerarFiltro", "", "");
    },
    gerarFiltroOData() {
      let filter = this.regraFiltro;
      let filtroOdata = "";

      // if (filter.condicao === "and") {
      //   filtroOdata = this.buildAndQuery(filter.regras);
      // } else if (filter.condicao === "or") {
      //   filtroOdata = this.buildOrQuery(filter.regras);
      // } else {
      //   filtroOdata = "";
      // }

      filtroOdata = this.buildSingleQuery(filter);

      if (filtroOdata != "") {
        filtroOdata = "&$filter=" + filtroOdata;
      }

      return filtroOdata;
    },
    async aplicarFiltro() {
      var filtroOdata = this.gerarFiltroOData();
      if (filtroOdata != "") {
        const expandedSelectQuery = this.applyFilterToExpand(
          this.selectQuery,
          filtroOdata
        );

        this.$emit("gerarFiltro", filtroOdata, expandedSelectQuery);
      } else {
        await this.showInvalidAlert("Nenhum filtro foi selecionado!");
      }
    },
    applyFilterToExpand(selectQuery, filterQuery) {
      const anyMatches = filterQuery.match(/(\w+)\/any/g);

      if (!anyMatches) {
        return selectQuery;
      }

      const expands = anyMatches.map((match) => match.split("/")[0]);
      const filtersExpand = [];

      expands.forEach((expand) => {
        const filter = this.extractFilterForExpand(filterQuery, expand);
        if (filter) {
          const filterExpand = {
            expand: expand,
            filter: filter,
          };
          filtersExpand.push(filterExpand);
        }
      });

      let selectParts = [selectQuery];

      filtersExpand.forEach((filters) => {
        const newSelectParts = [];
        selectParts.forEach((part) => {
          if (part.includes(filters.expand)) {
            const splitPart = part.split(filters.expand);
            if (splitPart[1].charAt(0) === "(") {
              splitPart[1] = splitPart[1].substring(1);
            } else {
              splitPart[1] = splitPart[1] + ")";
            }

            newSelectParts.push(
              splitPart[0],
              `${filters.expand}($filter=(${filters.expand});${splitPart[1]}`
            );
          } else {
            newSelectParts.push(part);
          }
        });
        selectParts = newSelectParts;
      });

      let finalSelectQuery = selectParts.join("");

      filtersExpand.forEach((filters) => {
        finalSelectQuery = finalSelectQuery.replace(
          `$filter=(${filters.expand});`,
          `$filter=(${filters.filter});`
        );
      });

      return finalSelectQuery;
    },
    extractFilterForExpand(filterQuery, expand) {
      const filter = filterQuery.split(`${expand}/any`)[1];
      const openIndex = filter.indexOf("(");
      const closeIndex = this.findClose(filter, openIndex);
      let subExpression = filter.substring(openIndex + 1, closeIndex);
      subExpression = subExpression
        .replaceAll(`${expand}:`, "")
        .replaceAll(`${expand}/`, "")
        .trim();
      const operadoresSecundarios = this.extractOperador(subExpression);
      const operadoresPrimarios = this.extractOperadorPrimario(
        filterQuery,
        expand
      );

      //Ajustar verificação de quando incluir filter no expand se necessário
      if (operadoresPrimarios.length > 0) {
        if (operadoresPrimarios[0] === "and") {
          return subExpression;
        }
      }

      return subExpression;
    },
    findClose(expression, startIndex) {
      let count = 0;
      for (let i = startIndex; i < expression.length; i++) {
        if (expression[i] === "(") {
          count++;
        } else if (expression[i] === ")") {
          count--;
          if (count === 0) {
            return i;
          }
        }
      }
      return -1; // Parêntese de fechamento não encontrado
    },
    extractOperador(expression) {
      while (expression.includes("(")) {
        const openIndex = expression.indexOf("(");
        const closeIndex = this.findClose(expression, openIndex);
        const subExpression = expression.substring(openIndex, closeIndex + 1);

        expression = expression.replace(subExpression, " ");
      }

      const operadores = expression.split(/\s+/);
      return operadores.filter(
        (operador) =>
          operador !== "" && (operador === "and" || operador === "or")
      );
    },
    extractOperadorPrimario(expression, expand) {
      const expandIndex = expression.indexOf(`${expand}/any`);
      const openIndex = expression.substring(0, expandIndex).lastIndexOf("(");
      const closeIndex = this.findClose(expression, openIndex);
      let subExpression = expression.substring(openIndex, closeIndex + 1);

      let filter = expression.split(subExpression);

      const inicioSize = filter[0].length;
      if (inicioSize >= 4) {
        let operadorInicio = filter[0].substring(inicioSize - 4, inicioSize);
        if (operadorInicio.includes("and") || operadorInicio.includes("or")) {
          filter[0] = operadorInicio.trim();
        } else {
          filter[0] = "";
        }
      } else {
        filter[0] = "";
      }

      const finalSize = filter[1].length;
      if (finalSize >= 4) {
        let operadorFinal = filter[1].substring(0, 4);
        if (operadorFinal.includes("and") || operadorFinal.includes("or")) {
          filter[1] = operadorFinal.trim();
        } else {
          filter[1] = "";
        }
      } else {
        filter[1] = "";
      }

      return filter.filter(
        (operador) =>
          operador !== "" && (operador === "and" || operador === "or")
      );
    },
    // buildAndQuery(regras) {
    //   return regras.map((regra) => this.buildSingleQuery(regra)).join(" and ");
    // },
    // buildOrQuery(regras) {
    //   return regras.map((regra) => this.buildSingleQuery(regra)).join(" or ");
    // },
    buildSingleQuery(regra) {
      if (regra.condicao === "and" || regra.condicao === "or") {
        const subQueries = regra.regras
          .map((subRegra) => {
            let query = this.buildSingleQuery(subRegra);
            return query;
          })
          .filter((query) => query !== "");
        const operadorLogico = regra.condicao === "and" ? " and " : " or ";
        const groupedSubQueries = this.groupSameTableConditions(
          subQueries,
          operadorLogico
        );

        if (groupedSubQueries.length > 1) {
          return `(${groupedSubQueries.join(operadorLogico)})`;
        } else if (groupedSubQueries.length === 1) {
          return groupedSubQueries[0];
        } else {
          return "";
        }
      } else {
        if (regra.tipo === "object") {
          regra = JSON.parse(JSON.stringify(regra));
          regra.campo_original = regra.campo;
          regra.campo = "";
          regra = this.retornaRegraObjeto(regra);
        }
        const tipoOperadores = this.operadores[regra.tipo];
        const operador = tipoOperadores.find(
          (op) => op.valor === regra.operador
        );

        var campo = regra.campo;
        var valor = regra.valor;
        const valorEntre = regra.valor_entre;
        var campoAny = "";

        if (campo.includes("any")) {
          var indice = campo.lastIndexOf(":");

          if (indice !== -1) {
            campoAny = campo.substring(0, indice + 1);
            campo = campo.substring(indice + 1).trim();
          } else {
            console.log("Caractere ':' não encontrado");
          }
        }

        if (
          !operador ||
          !campo ||
          campo === "" ||
          ((!valor || valor === "") &&
            operador.valor !== "equal" &&
            operador.valor !== "isempty" &&
            operador.valor !== "isnotempty" &&
            operador.valor !== "isnull" &&
            operador.valor !== "isnotnull")
        ) {
          return "";
        }

        if (!regra.tipo === "datetime") {
          if (!this.$utils.isNumeric(valor)) {
            valor = valor.replace("'", "''");
          }
        }

        let query = "";

        if (regra.tipo === "text") {
          if (operador.valor === "startswith") {
            query = `startswith(${campo}, '${valor}')`;
          } else if (operador.valor === "endswith") {
            query = `endswith(${campo}, '${valor}')`;
          } else if (operador.valor === "contains") {
            query = `contains(${campo}, '${valor}')`;
          } else if (operador.valor === "equal") {
            query = `${campo} eq '${valor}'`;
          } else if (operador.valor === "notequal") {
            query = `${campo} ne '${valor}'`;
          } else if (operador.valor === "in") {
            const valores = valor.split(",").map((v) => v.trim());
            query = `${campo} in ('${valores.join("','")}')`;
          } else if (operador.valor === "notin") {
            const valores = valor.split(",").map((v) => v.trim());
            query = `not(${campo} in ('${valores.join("','")}'))`;
          } else if (operador.valor === "isempty") {
            query = `${campo} eq ''`;
          } else if (operador.valor === "isnotempty") {
            query = `${campo} ne ''`;
          } else if (operador.valor === "isnull") {
            query = `${campo} eq null`;
          } else if (operador.valor === "isnotnull") {
            query = `${campo} ne null`;
          }
        } else if (regra.tipo === "number" || regra.tipo === "decimal") {
          if (operador.valor === "equal") {
            query = `${campo} eq ${valor}`;
          } else if (operador.valor === "notequal") {
            query = `${campo} ne ${valor}`;
          } else if (operador.valor === "greaterthan") {
            query = `${campo} gt ${valor}`;
          } else if (operador.valor === "greaterthanorequal") {
            query = `${campo} ge ${valor}`;
          } else if (operador.valor === "lessthan") {
            query = `${campo} lt ${valor}`;
          } else if (operador.valor === "lessthanorequal") {
            query = `${campo} le ${valor}`;
          } else if (operador.valor === "between") {
            query = `${campo} ge ${valor} and ${campo} le ${valorEntre}`;
          } else if (operador.valor === "notbetween") {
            query = `${campo} lt ${valor} or ${campo} gt ${valorEntre}`;
          } else if (operador.valor === "in") {
            const valores = valor.split(",").map((v) => v.trim());
            query = `${campo} in (${valores.join(",")})`;
          } else if (operador.valor === "notin") {
            const valores = valor.split(",").map((v) => v.trim());
            query = `not(${campo} in (${valores.join(",")}))`;
          } else if (operador.valor === "isnull") {
            query = `${campo} eq null`;
          } else if (operador.valor === "isnotnull") {
            query = `${campo} ne null`;
          }
        } else if (regra.tipo === "datetime") {
          if (operador.valor === "equal") {
            query = `${campo} eq ${this.formatData(valor)}`;
          } else if (operador.valor === "notequal") {
            query = `${campo} ne ${this.formatData(valor)}`;
          } else if (operador.valor === "greaterthan") {
            query = `${campo} gt ${this.formatDataHora(valor, regra.utc)}`;
          } else if (operador.valor === "greaterthanorequal") {
            query = `${campo} ge ${this.formatDataHora(valor, regra.utc)}`;
          } else if (operador.valor === "lessthan") {
            query = `${campo} lt ${this.formatDataHora(valor, regra.utc)}`;
          } else if (operador.valor === "lessthanorequal") {
            query = `${campo} le ${this.formatDataHora(valor, regra.utc)}`;
          } else if (operador.valor === "between") {
            query = `${campo} ge ${this.formatDataHora(
              valor,
              regra.utc
            )} and ${campo} le ${this.formatDataHora(valorEntre, regra.utc)}`;
          } else if (operador.valor === "notbetween") {
            query = `${campo} lt ${this.formatDataHora(
              valor,
              regra.utc
            )} or ${campo} gt ${this.formatDataHora(valorEntre, regra.utc)}`;
          } else if (operador.valor === "isnull") {
            query = `${campo} eq null`;
          } else if (operador.valor === "isnotnull") {
            query = `${campo} ne null`;
          }
        }

        if (campoAny !== "") {
          query = `${campoAny} ${query}`;
        }

        var qtd = query.split("any").length - 1;
        var fecha = `)`.repeat(qtd);

        return `(${query})${fecha}`;
      }
    },
    retornaRegraObjeto(regra) {
      if (regra.operador === "array") {
        regra.campo = `${regra.campo ? regra.campo + "/" : ""}${
          regra.campo_original
        }/any(${regra.campo_original}: ${regra.campo_original}`;
      } else {
        regra.campo = `${regra.campo ? regra.campo + "/" : ""}${
          regra.campo_original
        }`;
      }
      let objeto = regra.campo;
      regra = JSON.parse(JSON.stringify(regra.regra));
      regra.campo_original = regra.campo;
      regra.campo = objeto;
      if (regra.tipo === "object") {
        regra = this.retornaRegraObjeto(regra);
      } else {
        regra.campo = `${objeto}/${regra.campo_original}`;
      }
      return regra;
    },
    groupSameTableConditions(subQueries, operadorLogico) {
      const groupedQueries = {};

      for (const query of subQueries) {
        const anyMatch = query.match(/\/any\((.*?):/);
        if (anyMatch) {
          const tableName = anyMatch[1];
          if (!groupedQueries[tableName]) {
            groupedQueries[tableName] = [];
          }
          const regex = new RegExp(`any\\(${tableName}: (.*)\\)\\)`);
          let newQuery = query.match(regex)[1];
          groupedQueries[tableName].push(`(${newQuery})`);
        } else {
          groupedQueries["_no_any"] = groupedQueries["_no_any"] || [];
          groupedQueries["_no_any"].push(query);
        }
      }

      const resultQueries = [];

      for (const tableName in groupedQueries) {
        if (tableName === "_no_any") {
          resultQueries.push(...groupedQueries[tableName]);
        } else {
          const conditions = groupedQueries[tableName].join(operadorLogico);
          resultQueries.push(`(${tableName}/any(${tableName}: ${conditions}))`);
        }
      }

      return resultQueries;
    },
    formatDataHora(data, utc) {
      const date = utc ? this.$utils.removerFusoHorario(data) : new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${this.$utils.getTimeZoneServidor()}`;
    },
    formatData(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.ConsultaAvancada.Consultar") {
            this.consultarConsultaAvancada = true;
          }
          if (element.regra === "Permitir.ConsultaAvancada.Incluir") {
            this.adicionarConsultaAvancada = true;
          }
          if (element.regra === "Permitir.ConsultaAvancada.Alterar") {
            this.editarConsultaAvancada = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    await this.getSchema();

    $bus.on("aplicar-select-filter", () => {
      if (this.gerarFiltroOData() != "") {
        this.aplicarFiltro();
      }
    });
  },
  unmounted() {
    $bus.off("aplicar-select-filter");
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      consultarConsultaAvancada: false,
      adicionarConsultaAvancada: false,
      editarConsultaAvancada: false,
      exibirEditarDescricaoFiltro: false,
      exibirConsultaAvancada: false,
      consultaAvancada: JSON.parse(
        JSON.stringify(consultaAvancadaInicializada)
      ),
      timeOut: null,
      loading: false,
      model: {},
      regraFiltro: {
        condicao: "and",
        regras: [
          {
            campo: "",
            operador: "",
            tipo: "",
            valor: "",
            valor_entre: "",
            utc: false,
          },
        ],
      },
      operadores: {
        text: [
          { descricao: "começa com", valor: "startswith" },
          { descricao: "termina com", valor: "endswith" },
          { descricao: "contém", valor: "contains" },
          { descricao: "é igual à", valor: "equal" },
          { descricao: "é diferente de", valor: "notequal" },
          { descricao: "está dentro de", valor: "in" },
          { descricao: "não está dentro de", valor: "notin" },
          { descricao: "é vazio", valor: "isempty" },
          { descricao: "não é vazio", valor: "isnotempty" },
          { descricao: "é nulo", valor: "isnull" },
          { descricao: "não é nulo", valor: "isnotnull" },
        ],
        number: [
          { descricao: "é igual à", valor: "equal" },
          { descricao: "é diferente de", valor: "notequal" },
          { descricao: "é maior que", valor: "greaterthan" },
          { descricao: "é maior ou igual à", valor: "greaterthanorequal" },
          { descricao: "é menor que", valor: "lessthan" },
          { descricao: "é menor ou igual à", valor: "lessthanorequal" },
          { descricao: "está entre", valor: "between" },
          { descricao: "não está entre", valor: "notbetween" },
          { descricao: "está dentro de", valor: "in" },
          { descricao: "não está dentro de", valor: "notin" },
          { descricao: "é nulo", valor: "isnull" },
          { descricao: "não é nulo", valor: "isnotnull" },
        ],
        decimal: [
          { descricao: "é igual à", valor: "equal" },
          { descricao: "é diferente de", valor: "notequal" },
          { descricao: "é maior que", valor: "greaterthan" },
          { descricao: "é maior ou igual à", valor: "greaterthanorequal" },
          { descricao: "é menor que", valor: "lessthan" },
          { descricao: "é menor ou igual à", valor: "lessthanorequal" },
          { descricao: "está entre", valor: "between" },
          { descricao: "não está entre", valor: "notbetween" },
          { descricao: "está dentro de", valor: "in" },
          { descricao: "não está dentro de", valor: "notin" },
          { descricao: "é nulo", valor: "isnull" },
          { descricao: "não é nulo", valor: "isnotnull" },
        ],
        datetime: [
          { descricao: "é igual à", valor: "equal" },
          { descricao: "é diferente de", valor: "notequal" },
          { descricao: "é maior que", valor: "greaterthan" },
          { descricao: "é maior ou igual à", valor: "greaterthanorequal" },
          { descricao: "é menor que", valor: "lessthan" },
          { descricao: "é menor ou igual à", valor: "lessthanorequal" },
          { descricao: "está entre", valor: "between" },
          { descricao: "não está entre", valor: "notbetween" },
          { descricao: "é nulo", valor: "isnull" },
          { descricao: "não é nulo", valor: "isnotnull" },
        ],
        object: [
          { descricao: "object", valor: "object" },
          { descricao: "array", valor: "array" },
        ],
      },
      json1: {
        condicao: "and",
        regras: [
          {
            campo: "id",
            operador: "greaterthan",
            tipo: "number",
            valor: 60,
            valor_entre: "",
            utc: false,
          },
          {
            condicao: "and",
            regras: [
              {
                campo: "PedidoItem",
                operador: "array",
                tipo: "object",
                valor: "",
                valor_entre: "",
                utc: false,
                regra: {
                  campo: "PedidoSubItem",
                  operador: "array",
                  tipo: "object",
                  valor: "",
                  valor_entre: "",
                  utc: false,
                  regra: {
                    campo: "descricao",
                    operador: "equal",
                    tipo: "text",
                    valor: "Natural",
                    valor_entre: "",
                    utc: false,
                  },
                },
              },
              {
                condicao: "or",
                regras: [
                  {
                    campo: "PedidoItem",
                    operador: "array",
                    tipo: "object",
                    valor: "",
                    valor_entre: "",
                    utc: false,
                    regra: {
                      campo: "id_produto",
                      operador: "equal",
                      tipo: "number",
                      valor: 11,
                      valor_entre: "",
                      utc: false,
                    },
                  },
                  {
                    campo: "PedidoItem",
                    operador: "array",
                    tipo: "object",
                    valor: "",
                    valor_entre: "",
                    utc: false,
                    regra: {
                      campo: "id_produto",
                      operador: "equal",
                      tipo: "number",
                      valor: 30,
                      valor_entre: "",
                      utc: false,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
};
</script>

<style></style>
